import { classNames } from '@utils/classNames';
import React, { ChangeEventHandler } from 'react';

export default function TextAreaInput({
    label,
    value,
    touched,
    error,
    handleBlur,
    handleChange,
    id,
    name,
    containerClassName,
    inputClassName,
    disabled,
}: Readonly<{
    label: string;
    value: string;
    touched?: boolean;
    error?: string;
    handleBlur: (e: React.FocusEvent<any>) => void;
    handleChange: ChangeEventHandler<HTMLTextAreaElement>;
    name: string;
    id: string;
    containerClassName?: string;
    inputClassName?: string;
    disabled?: boolean;
}>) {
    return (
        <div
            className={classNames(
                'flex flex-col w-full space-y-2',
                containerClassName,
            )}
        >
            <label htmlFor={id} className="text-xl">
                {label}
            </label>
            <textarea
                id={id}
                name={name}
                className={classNames(
                    'text-black px-4 py-3 border border-border',
                    inputClassName,
                )}
                onInput={handleChange}
                onBlur={handleBlur}
                value={value}
                disabled={disabled}
            />
            {error && touched && <p className="text-error">{error}</p>}
        </div>
    );
}
